<sc-auth-page-wrapper mainTitle="¡Hola!" [subtitle]="subtitle" [authAction]="authAction">
  <form auth-page-wrapper-content [formGroup]="form" class="text-center">
    <sc-tooltip-input-decorator *ngIf="showTooltip" [tooltipText]="tooltipText" placement="bottom">
      <sc-input
        [maxlength]="userIdMaxLength"
        [pipes]="pipes"
        [errorMessages]="userIdErrorMessages"
        [placeholder]="userIdLabel"
        [label]="userIdLabel"
        [debounceTime]="400"
        autocomplete="off"
        formControlName="userId"
        icon="question-elipse"
        type="text"
      ></sc-input>
    </sc-tooltip-input-decorator>
    <sc-input
      *ngIf="!showTooltip"
      [maxlength]="userIdMaxLength"
      [placeholder]="userIdLabel"
      [pipes]="pipes"
      [errorMessages]="userIdErrorMessages"
      [label]="userIdLabel"
      [debounceTime]="400"
      autocomplete="off"
      formControlName="userId"
      type="text"
    ></sc-input>
    <sc-input
      [maxlength]="passwordMaxLength"
      [debounceTime]="400"
      autocomplete="off"
      formControlName="password"
      placeholder="Contraseña"
      label="Contraseña"
      type="password"
      required
    ></sc-input>
    <div class="login__forgot-password">
      <a 
        id="go-to-forgotten-password"
        class="login__forgot-password-link"
        [routerLink]="appRoutes.resetPassword"
      >¿Olvidaste tu contraseña?</a>
      <sc-checkbox class="sc-checkbox__small" formControlName="rememberMe">Recordarme</sc-checkbox>
    </div>
    <sc-button type="primary" (onClick)="login()" [loading]="isLoading" [disabled]="isLoading || form.invalid || isLoggingIntoAD" id="login-button">
      Ingresar
    </sc-button>
    <div class="login-ad" *ngIf="showADLogin">
      <sc-button
        type="link-secondary"
        (onClick)="loginActiveDirectory()"
        [loading]="isLoggingIntoAD"
        [disabled]="isLoading || isLoggingIntoAD"
        id="loginAD-button">
          ¿Sos usuario interno? Hacé click acá
      </sc-button>
    </div>
    <sc-auth-error-messages [error]="error"></sc-auth-error-messages>
  </form>
  <div auth-page-wrapper-footer>
    <sc-auth-actions class="footer-action" [authAction]="authAction"></sc-auth-actions>
    <sc-auth-legal-footer></sc-auth-legal-footer>
  </div>
</sc-auth-page-wrapper>